import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'lodash';
import { BarLoader } from '@unite-us/ui';
import EditPhoneNumbers from './EditPhoneNumbers';
import PhoneNumberDisplay from './PhoneNumberDisplay';
import RowDisplay from '../../common/RowDisplay';
import { primaryFirstPhoneSort } from './EditPhoneNumbers/utils';
import EditModal from '../../common/modal/EditModal';
import generatePhonesWithExtension from '../../utils/generatePhonesWithExtension';
import './PhoneNumbers.scss';
var PhoneNumbers = function PhoneNumbers(_ref) {
  var groupId = _ref.groupId,
    phoneFor = _ref.phoneFor,
    phoneNumbers = _ref.phoneNumbers,
    phoneTypes = _ref.phoneTypes,
    onSave = _ref.onSave,
    isFetching = _ref.isFetching,
    lastUpdate = _ref.lastUpdate,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate;
  var processedNumbers = generatePhonesWithExtension(phoneNumbers);
  var phoneDisplay = function phoneDisplay() {
    var _context;
    return _mapInstanceProperty(_context = primaryFirstPhoneSort(processedNumbers)).call(_context, function (phone) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6 phone-numbers__phone-number-display",
        key: "phoneDisplay-".concat(phone.id)
      }, /*#__PURE__*/React.createElement(PhoneNumberDisplay, {
        item: phone,
        detailedExtension: true
      }));
    });
  };
  var editSection = /*#__PURE__*/React.createElement(EditModal, {
    header: "Edit Phone Number",
    size: "large",
    formName: "edit-phone-numbers",
    editButtonId: "edit-phone-number-btn",
    id: "edit-phone-number-modal"
  }, isFetching ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BarLoader, {
    className: "mb-quarter",
    size: "semi-full"
  }), /*#__PURE__*/React.createElement(BarLoader, {
    className: "mb-quarter",
    size: "half"
  }), /*#__PURE__*/React.createElement(BarLoader, {
    className: "mb-quarter",
    size: "semi-full"
  })) : /*#__PURE__*/React.createElement(EditPhoneNumbers, {
    groupId: groupId,
    numbers: processedNumbers,
    onSave: onSave,
    phoneFor: phoneFor,
    phoneTypes: phoneTypes
  }));
  return /*#__PURE__*/React.createElement(RowDisplay, {
    className: "phone-numbers",
    editSection: editSection,
    label: "Phone",
    lastUpdate: lastUpdate,
    showLastUpdate: shouldShowLastUpdate
  }, phoneDisplay());
};
PhoneNumbers.propTypes = {
  onSave: PropTypes.func,
  phoneFor: PropTypes.oneOf(['contact', 'group']),
  phoneNumbers: PropTypes.array,
  phoneTypes: PropTypes.array.isRequired,
  lastUpdate: PropTypes.object,
  shouldShowLastUpdate: PropTypes.bool
};
PhoneNumbers.defaultProps = {
  phoneFor: 'contact',
  phoneNumbers: [],
  onSave: noop,
  lastUpdate: {
    recently_updated_by_name: null,
    recently_updated_at: null
  },
  shouldShowLastUpdate: false
};
export default PhoneNumbers;
//# sourceMappingURL=index.js.map